import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../lib/api';
import { Icon } from '../lib/icons';

interface RankItem {
  rank: number;
  memorialId: string;
  slug: string;
  deceasedName: string;
  memorialType: string;
  heroCategory: string | null;
  tributeCount: number;
  viewCount: number;
  xiaoxinCents: number;
  /** 综合热度：祭奠×20 + 瞻仰 + 孝心值（元） */
  hotScore: number;
}

const fmtYuan = (cents: number) => `¥${((cents ?? 0) / 100).toFixed(2)}`;
const MEDAL = ['text-yellow-500', 'text-slate-400', 'text-amber-700'];

export default function Leaderboard() {
  const [items, setItems] = useState<RankItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api<{ items: RankItem[] }>('/leaderboard?limit=50').then((res) => {
      if (res.ok && res.data) setItems(res.data.items);
      setLoading(false);
    });
  }, []);

  return (
    <div className="min-h-screen bg-ink-50/40">
      <header className="border-b border-ink-100 bg-white/80 backdrop-blur">
        <div className="mx-auto flex max-w-3xl items-center justify-between px-6 py-4">
          <Link to="/" className="flex items-center gap-2 text-ink-800">
            <span className="text-lg font-serifcn">线上墓迪</span>
          </Link>
          <Link to="/heroes" className="text-xs text-ink-500 underline">
            英雄纪念堂
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-6 py-8">
        <div className="mb-6 text-center">
          <h1 className="font-serifcn text-2xl text-ink-900">孝心排行榜</h1>
          <p className="mt-1 text-sm text-ink-500">
            按祭奠热度综合排名：祭奠留言、瞻仰人次与孝心值，清明祭扫，孝心无价
          </p>
        </div>

        {loading ? (
          <p className="text-center text-sm text-ink-500">加载中…</p>
        ) : items.length === 0 ? (
          <p className="text-center text-sm text-ink-400">
            还没有产生祭奠记录，去纪念馆留下第一份追思吧
          </p>
        ) : (
          <ul className="space-y-2">
            {items.map((it) => (
              <li key={it.memorialId}>
                <Link
                  to={`/m/${it.slug}`}
                  className="flex items-center gap-4 rounded-2xl border border-ink-100 bg-white px-4 py-3 transition hover:border-ink-300"
                >
                  <span className="flex w-8 justify-center text-xl font-bold text-ink-400">
                    {it.rank <= 3 ? <Icon name="medal" className={MEDAL[it.rank - 1]} /> : it.rank}
                  </span>
                  <div className="min-w-0 flex-1">
                    <p className="truncate text-ink-900">{it.deceasedName}</p>
                    <p className="text-xs text-ink-400">
                      {it.memorialType === 'hero' ? `英雄 · ${it.heroCategory ?? ''}` : '亲友纪念馆'} ·{' '}
                      {it.tributeCount} 次祭奠 · {it.viewCount} 次瞻仰
                    </p>
                  </div>
                  <div className="text-right">
                    <p className="font-serifcn text-candle-600">{fmtYuan(it.xiaoxinCents)}</p>
                    <p className="text-[10px] text-ink-400">孝心值</p>
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </main>
    </div>
  );
}
